export enum CommonLocalStorageKeyEnum {
  CITIES = 'cities',
  PROVINCES = 'provinces',
  CLIENT_MODULES = 'client-modules',
  GENERAL_CONFIGS = 'general-configs',
  INSURANCE_MODULES = 'insurance-modules',
  MENU_CATEGORIES = 'menu-categories',
}
